import { axiosInstance } from "./apiInstance";

export const getTags = () => {
  const response = axiosInstance.get("/api/inkle/tags/COMPANY_GROUP_TAG/");
  return response;
};
